/**
 * MarketingAudienceEditPage — deep link from audience cards "Edit".
 * Hosts SegmentBuilder and opens the editor for the given segment id.
 */

import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PillarPageShell from "../shared/PillarPageShell";
import SegmentBuilder from "../../communications/SegmentBuilder";

const LIST_PATH = "/dashboard/communications/marketing/audiences";

const MarketingAudienceEditPage: React.FC = () => {
  const { segmentId } = useParams<{ segmentId: string }>();
  const navigate = useNavigate();

  if (!segmentId) {
    return (
      <PillarPageShell pillar="marketing" title="Edit audience">
        <Alert severity="error">Invalid link.</Alert>
      </PillarPageShell>
    );
  }

  return (
    <PillarPageShell
      pillar="marketing"
      title="Edit audience"
      subtitle="Change filters, run preview count, then save. Use Back to return to the audience list."
      rightActions={
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(LIST_PATH)}
          size="small"
          variant="outlined"
        >
          Back to audiences
        </Button>
      }
    >
      <Box sx={{ maxWidth: 1200, mx: "auto" }}>
        <SegmentBuilder initialEditSegmentId={segmentId} />
      </Box>
    </PillarPageShell>
  );
};

export default MarketingAudienceEditPage;
